export default __webpack_public_path__ + "static/media/eigenheim_icons_hand.e382c88f.svg";